import {Component} from 'react';
import PropTypes from 'prop-types';

class ValueRender extends Component {
    render() {
        if(this.props.propertyDefinition && this.props.propertyDefinition.type) {
            switch (this.props.propertyDefinition.type) {
                case 'AppBundle\\Form\\Type\\ValueSelectType':
                    let possibleValue = this.props.propertyDefinition.possibleValues[this.props.value];
                    return possibleValue[this.props.renderAttribute];

                default:
                    return this.props.value
            }
        }
        else {
            return this.props.value;
        }
    }
}

ValueRender.propTypes = {
    propertyDefinition   : PropTypes.object.isRequired,
    renderAttribute: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};

export default ValueRender



// WEBPACK FOOTER //
// ./src/components/reusables/ValueRender.js